/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./lotteryDetail.vue?vue&type=template&id=6728188b&scoped=true"
import script from "./lotteryDetail.vue?vue&type=script&lang=js"
export * from "./lotteryDetail.vue?vue&type=script&lang=js"
import style0 from "./lotteryDetail.vue?vue&type=style&index=0&id=6728188b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728188b",
  null
  
)

export default component.exports